export default __webpack_public_path__ + "static/media/ddl-arrow.953d0cf3.svg";